// Story-route CTAs now have real Variant 1 pages for /team, /sticht, and
// /visie; the legacy /gezondeschool route redirects to its evidence on /visie.
// Keep stale external CMS values normalized here so public content does not
// regress while CMS metadata catches up.
const SAFE_ROUTE_OVERRIDES = {
  "https://www.gezondeschool.nl": "https://www.gezondeschool.nl/primair-onderwijs",
  "https://www.gezondeschool.nl/": "https://www.gezondeschool.nl/primair-onderwijs",
  "/groepsouders": "/oudervereniging",
};

const GROUP_BUILD_ROUTES = {
  "1–2": "/groepen/kleuters",
  "3–4": "/groepen/onderbouw",
  "5–6": "/groepen/middenbouw",
  "7–8": "/groepen/bovenbouw",
};

const LEGACY_GROUP_QUERY_ROUTES = {
  "/groepen?bouw=kleuters": "/groepen/kleuters",
  "/groepen?bouw=onderbouw": "/groepen/onderbouw",
  "/groepen?bouw=middenbouw": "/groepen/middenbouw",
  "/groepen?bouw=bovenbouw": "/groepen/bovenbouw",
};

export function normalizeStoryRouteTarget(target) {
  if (!target) return "";
  return SAFE_ROUTE_OVERRIDES[target] || target;
}

export function normalizeRouteStepTarget(target, badge) {
  if (target === "/groepen" && GROUP_BUILD_ROUTES[badge]) {
    return GROUP_BUILD_ROUTES[badge];
  }
  return LEGACY_GROUP_QUERY_ROUTES[target] || target;
}

export function storyRouteLinkProps(target) {
  const normalized = normalizeStoryRouteTarget(target);
  if (/^https?:\/\//i.test(normalized)) {
    return {
      component: "a",
      href: normalized,
      target: "_blank",
      rel: "noopener noreferrer",
    };
  }
  return { to: normalized };
}
